const getCustomStyling = (): string => (
  `
    .btn-row .btn--grey {
      border-radius: 6px;
      font-size: 1.125rem;
      line-height: 1.75rem;
    }

    .table-result .c-table__thead th,
    .table-result .c-table__tbody th,
    .table-result .c-table__tbody td {
      font-size: 1.125rem;
      line-height: 1.5rem;
      font-weight: 800;
      padding: 16px;
      border: 2px solid transparent;
    }

    .table-result .c-table__tbody td span {
      display: block;
      width: 100%;
      height: 100%;
    }

    .table-result .c-table__tbody td.rating-1 span::before,
    .table-result .c-table__tbody td.rating-2 span::before,
    .table-result .c-table__tbody td.rating-3 span::before {
      content: '';
      display: inline-block;
      margin-right: 8px;
      width: 22px;
      height: 22px;
      vertical-align: text-bottom;
    }

    .btn-row .btn--grey {
      border-radius: 6px;
      font-size: 1.125rem;
      line-height: 1.75rem;
    }

    .table-result .c-table__thead th,
    .table-result .c-table__tbody th,
    .table-result .c-table__tbody td {
      font-size: 1.125rem;
      line-height: 1.5rem;
      font-weight: 800;
      padding: 16px;
      border: 2px solid transparent;
    }

    .table-result .c-table__tbody td span {
      display: block;
      width: 100%;
      height: 100%;
    }

    .table-result .c-table__tbody td.rating-1 span::before,
    .table-result .c-table__tbody td.rating-2 span::before,
    .table-result .c-table__tbody td.rating-3 span::before {
      content: '';
      display: inline-block;
      margin-right: 8px;
      width: 22px;
      height: 22px;
      vertical-align: text-bottom;
    }

    #survey-result {
      padding: 4px;
    }

    .survey-audience {
      padding-bottom: 15px;
    }

    .survey-audience__image {
      margin-left: 2px;
      max-width: 22px;
      max-height: 22px;
    }

    .table-result .c-table {
      border-collapse: separate;
      border-spacing: 8px;
    }

    .table-result .c-table__thead th {
      text-align: center;
      background-color: #fff;
    }

    .table-result .c-table__tbody th {
      padding: 16;
      vertical-align: middle;
      text-align: left;
    }

    .table-result .c-table__tbody th:focus-within {
      outline: dotted;
    }

    .table-result .c-table__tbody th a {
      outline: none;
    }

    .table-result .c-table__tbody td {
      text-align: center;
      vertical-align: middle;
    }

    .table-result .c-table__tbody td:focus {
      outline: dotted;
    }

    .table-result .c-table__tbody td span::before {
      content: '';
      width: 22px;
      height: 22px;
    }

    .table-result .c-table__tbody td.rating-1 {
      border-color: #d52b1e;
    }

    .table-result .c-table__tbody td.rating-1 span::before {
      background-color: #d52b1e;
    }

    .table-result .c-table__tbody td.rating-2 {
      border-color: #e17000;
    }

    .table-result .c-table__tbody td.rating-2 span::before {
      background-color: #e17000;
    }

    .table-result .c-table__tbody td.rating-3 {
      border-color: #39870c;
    }

    .table-result .c-table__tbody td.rating-3 span::before {
      background-color: #39870c;
    }

    .table-result .c-table__link {
      position: relative;
      padding: 16px 40px 16px 16px;
      color: #fff;
      text-decoration: underline;
    }

    .table-result .c-table__link::after {
      position: absolute;
      display: block;
      content: '';
      background-repeat: no-repeat;
      background-size: cover;
      background-image: url(/static/media/chevron-right-white.3194bdec.svg);
      width: 16px;
      height: 16px;
      top: 50%;
      right: 16px;
      transform: translateY(-8px);
      transition: transform 0.15s ease-in-out;
    }

    .table-result .c-table__link:hover {
      text-decoration: underline;
    }

    .table-result .c-table__link:hover::after {
      transform: translate(5px, -8px);
    }

    .table-result .c-table__link__text {
      margin-right: 16px;
    }

    .table-result .c-table__img {
      margin-right: 16px;
      max-width: 22px;
      max-height: 22px;
    }

    .completed-html {
      line-height: 1.75rem;
    }

    .completed-html h2,
    .completed-html h3 {
      margin-top: 80px;
      line-height: 3rem;
    }

    .completed-html .list-group-item {
      margin: 12px 0;
      padding: 16px 20px;
      line-height: 2rem;
    }

    .completed-html .list-group-item a {
      color: #000;
      text-decoration: underline solid #000 2px;
    }

    .completed-html .list-group-item a:focus {
      outline: dotted;
    }

    .completed-html .list-group-item div:last-child {
      margin-left: 36px;
    }

    .completed-html .list-group-item p {
      margin-bottom: 0;
      margin-top: 0;
    }

    .completed-html .list-group-item img {
      width: 148px;
      max-width: none;
      height: auto;
    }

    .completed-html ul.list-group .list-group-item:hover,
    .completed-html ul.list-group .list-group-item:focus {
      text-decoration: none;
    }

    .btn-row {
      margin-top: 80px;
    }

    .btn-row .btn--grey {
      margin-right: 32px;
      padding: 10px 20px;
      font-weight: 800;
      background-color: #ccc;
      transition: transform 0.15s ease-in-out;
    }

    .btn-row .btn--grey:hover {
      background-color: #b4b4b4;
    }

    .btn-row .btn--grey:focus {
      outline: dotted;
      outline-color: #000;
    }

    .icon {
      display: inline-block;
      line-height: 1rem;
    }

    .mint-green .c-table__thead th {
      color: #42145f !important;
    }

    .mint-green .survey-audience__image {
      max-width: 22px;
      max-height: 22px;
      filter: invert(11%) sepia(41%) saturate(4144%) hue-rotate(264deg) brightness(93%) contrast(101%) !important;
    }

    .mint-green .table-result .c-table__link {
      color: #42145f !important;
    }

    .mint-green .table-result .c-table__link::after {
      filter: invert(83%) sepia(80%) saturate(950%) hue-rotate(254deg) brightness(75%) contrast(95%);
    }

    .mint-green .table-result .c-table img {
      filter: invert(83%) sepia(80%) saturate(950%) hue-rotate(254deg) brightness(75%) contrast(95%);
    }

    .gk .table-result .c-table__link {
      color: #42145f;
    }

    .gk .table-result .c-table__link::after {
      background-image: url(/static/media/chevron-right-purple.8c2de661.svg);
    }

    @media screen and (max-width: 768px) {
      .c-table__img {
        display: none;
      }
    }

    @media screen and (max-width: 576px) {

      .completed-html h2,
      .completed-html h3 {
        margin-top: 24px;
        line-height: 1.75rem;
      }

      .completed-html .list-group-item {
        flex-direction: column !important;
        padding: 12px;
        font-size: 1.125rem;
        line-height: 1.75rem;
      }

      .completed-html .list-group-item div:last-child {
        margin-top: 12px;
        margin-left: 0;
      }

      .completed-html .list-group-item img {
        width: 100%;
      }

      .btn-row {
        margin-top: 24px;
      }
    }

    .is-print .gk .table-result .anchor-replace {
      padding: 16px 40px 16px 16px;
      color: #42145f !important;
    }

    .is-print .gs .table-result .anchor-replace {
      padding: 16px 40px 16px 16px;
      color: #fff !important;
    }

    .is-print .completed-html .list-group-item div:last-child {
      margin-left: 0;
    }

    .is-print .completed-html .list-group-item a {
      text-decoration: underline;
    }

    .is-print .completed-html .list-group-item a::after {
      content: '';
    }

    .is-print .completed-html .list-group-item img {
      display: none;
    }

    
    /*
 * refactor the classes conform rijks style-guide
 */
    .sv_main.sv_bootstrap_css .c-checkbox__decorator,
    .sv_main.sv_bootstrap_css .c-radio__decorator {
      position: absolute;
      top: 0;
      left: 0;
      background-color: #fff;
      border: 2px solid #000;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__decorator::after,
    .sv_main.sv_bootstrap_css .c-radio__decorator::after {
      content: "";
      position: absolute;
      display: none;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .sv_main.sv_bootstrap_css .c-checkbox__label,
    .sv_main.sv_bootstrap_css .c-radio__label {
      position: relative;
      cursor: pointer;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__label input,
    .sv_main.sv_bootstrap_css .c-radio__label input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    .sv_main.sv_bootstrap_css .c-panel__title,
    .sv_main.sv_bootstrap_css .c-checkbox__title {
      font-weight: 800;
      line-height: 2rem;
    }

    .sv_main.sv_bootstrap_css .btn--complete {
      border-radius: 6px;
      font-size: 1.125rem;
      line-height: 1.75rem;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__decorator,
    .sv_main.sv_bootstrap_css .c-radio__decorator {
      position: absolute;
      top: 0;
      left: 0;
      background-color: #fff;
      border: 2px solid #000;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__decorator::after,
    .sv_main.sv_bootstrap_css .c-radio__decorator::after {
      content: "";
      position: absolute;
      display: none;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .sv_main.sv_bootstrap_css .c-checkbox__label,
    .sv_main.sv_bootstrap_css .c-radio__label {
      position: relative;
      cursor: pointer;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__label input,
    .sv_main.sv_bootstrap_css .c-radio__label input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    .sv_main.sv_bootstrap_css .c-panel__title,
    .sv_main.sv_bootstrap_css .c-checkbox__title {
      font-weight: 800;
      line-height: 2rem;
    }

    .sv_main.sv_bootstrap_css .btn--complete {
      border-radius: 6px;
      font-size: 1.125rem;
      line-height: 1.75rem;
    }

    .sv_main.sv_bootstrap_css {
      background-color: #fff;
    }

    .sv_main.sv_bootstrap_css .sv_p_container,
    .sv_main.sv_bootstrap_css .sv_row {
      min-width: auto;
    }

    .sv_main.sv_bootstrap_css .c-body {
      padding: 5px;
    }

    .sv_main.sv_bootstrap_css .c-body__footer {
      padding: 0;
      background-color: #fff;
    }

    .sv_main.sv_bootstrap_css .btn--complete {
      position: relative;
      background-color: #01689b;
      border-color: #01689b;
      color: #fff;
      font-weight: 800;
    }

    .sv_main.sv_bootstrap_css .btn--complete:hover {
      color: #fff;
      background-color: #014f75;
      border-color: #014668;
    }

    .sv_main.sv_bootstrap_css .btn--complete:active {
      background-color: #01689b;
      border-color: #01689b;
    }

    .sv_main.sv_bootstrap_css .btn--complete:focus {
      box-shadow: none;
      outline: dotted;
      outline-color: #000;
    }

    .sv_main.sv_bootstrap_css .c-panel {
      margin-bottom: 28px;
      padding: 36px 42px 10px 42px;
      border-radius: 4px;
    }

    .sv_main.sv_bootstrap_css .c-panel__title {
      padding-left: 1em;
    }

    .sv_main.sv_bootstrap_css .c-panel__title img {
      margin-right: 16px;
      width: 34px;
      height: auto;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__decorator {
      margin: 12px 0 0 12px;
      height: 18px;
      width: 18px;
      border-radius: 4px;
    }

    .sv_main.sv_bootstrap_css .c-radio__decorator {
      margin: 5px 0;
      height: 18px;
      width: 18px;
      border-radius: 9px;
    }

    .sv_main.sv_bootstrap_css .c-radio__decorator::after {
      width: 9px;
      height: 9px;
      border-radius: 4.5px;
      background-color: #000;
    }

    .sv_main.sv_bootstrap_css .c-checkbox {
      padding: 0;
      min-width: auto !important;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__title {
      margin-bottom: 0;
      color: #000;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__description {
      font-size: 1.125rem;
      line-height: 1.5rem;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__group {
      margin: 20px -15px 0 -15px;
      width: 100%;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__label {
      width: 170px;
      height: 136px;
      padding: 12px;
      border-radius: 4px;
      line-height: 18px;
      background-color: #fff;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__label:hover .c-checkbox__decorator::after {
      display: block;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__label:focus-within {
      outline: dotted;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__label__text {
      width: 100%;
      height: 100%;
      text-align: center;
      font-size: 1.125rem;
      line-height: 1.375rem;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__label__text>span {
      width: 100%;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__label__text[title] {
      margin: 0;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__label__text img {
      display: block;
      margin: 0 auto 12px auto;
      max-width: 48px;
      max-height: 48px;
      width: 100%;
      height: auto;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__item {
      width: auto;
      padding: 0 18px 36px 18px;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__item--select-all {
      flex: 1 0 100%;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__item--select-all .c-checkbox__label {
      width: 196px;
      height: auto;
      font-size: 1.125rem;
      line-height: 1.5rem;
      font-weight: 800;
      color: #fff;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__item--select-all .c-checkbox__label__text {
      width: auto;
      padding-left: 20px;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__item.checked .c-checkbox__decorator::after {
      display: block;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__item.checked.c-checkbox__item--select-all .c-checkbox__decorator {
      background-color: #fff;
      border-color: #fff;
    }

    .sv_main.sv_bootstrap_css .c-checkbox__item.checked .c-checkbox__label {
      font-weight: 800;
    }

    .sv_main.sv_bootstrap_css .c-radio {
      position: relative;
      padding: 8px 16px 30px 16px;
      min-width: auto !important;
    }

    .sv_main.sv_bootstrap_css .c-radio::after {
      content: '';
      position: absolute;
      border: 1px solid #ccc;
      right: 16px;
      bottom: 18px;
      left: 16px;
    }

    .sv_main.sv_bootstrap_css .c-radio__title {
      font-weight: 800;
      line-height: 1.75rem;
    }

    .sv_main.sv_bootstrap_css .c-radio__label {
      padding-left: 23px;
    }

    .sv_main.sv_bootstrap_css .c-radio__label:hover .c-radio__decorator::after {
      display: block;
    }

    .sv_main.sv_bootstrap_css .c-radio__label:focus-within .c-radio__decorator {
      outline: dotted;
    }

    .sv_main.sv_bootstrap_css .c-radio__label__text {
      font-size: 1.125rem;
      line-height: 1.75rem;
    }

    .sv_main.sv_bootstrap_css .c-radio__label__text span {
      margin-left: 0;
    }

    .sv_main.sv_bootstrap_css .c-radio__item {
      width: auto;
    }

    .sv_main.sv_bootstrap_css .c-radio__item.checked .c-radio__decorator::after {
      display: block;
    }

    .sv_main.sv_bootstrap_css .c-dropdown-description__button {
      margin-left: 8px;
      width: 30px;
      height: 30px;
      padding: 0;
    }

    .sv_main.sv_bootstrap_css .c-dropdown-description__button:focus {
      outline: dotted;
    }

    .sv_main.sv_bootstrap_css .c-dropdown-description__button:active {
      box-shadow: none !important;
    }

    .sv_main.sv_bootstrap_css .c-dropdown-description__text {
      width: 100%;
      color: #535353;
    }

    .sv_main.sv_bootstrap_css .c-dropdown-description.collapsed .c-dropdown-description__text {
      display: block;
    }

    .sv_main.sv_bootstrap_css .c-dropdown-description .c-radio__title {
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: calc(100% - 38px);
    }

    .sv_main.sv_bootstrap_css .c-error {
      position: relative;
      padding: 16px 16px 16px 48px;
      border: none;
      border-top: 1px solid #d52b1e;
      color: #000;
      background-color: #f9dfdd;
    }

    .sv_main.sv_bootstrap_css .c-error__icon {
      display: block;
      position: absolute;
      top: 16px;
      left: 16px;
      margin-right: 48px;
      height: 20px;
      width: 20px;
      background-repeat: no-repeat;
      background-size: cover;
      background-image: url(/static/media/error.b16a80b9.svg);
    }

    @media screen and (max-width: 576px) {
      .sv_main.sv_bootstrap_css .c-panel {
        margin-bottom: 14px;
        padding: 24px 22px 10px 22px;
      }

      .sv_main.sv_bootstrap_css .c-panel__title img {
        margin-right: 16px;
        width: 24px;
        height: 24px;
      }

      .sv_main.sv_bootstrap_css .c-checkbox__title {
        line-height: 1.75rem;
      }

      .sv_main.sv_bootstrap_css .c-checkbox__group {
        margin-left: 0;
        margin-right: 0;
      }

      .sv_main.sv_bootstrap_css .c-checkbox__item {
        width: 100%;
        padding: 0;
      }

      .sv_main.sv_bootstrap_css .c-checkbox__item--select-all .c-checkbox__label {
        width: 100%;
      }

      .sv_main.sv_bootstrap_css .c-checkbox__item--select-all .c-checkbox__label__text {
        padding-left: 0;
      }

      .sv_main.sv_bootstrap_css .c-checkbox__label {
        width: 100%;
        height: auto;
        padding-left: 40px;
      }

      .sv_main.sv_bootstrap_css .c-checkbox__label__text {
        text-align: left;
      }

      .sv_main.sv_bootstrap_css .c-checkbox__label__text img {
        display: none;
      }
    }

    .mint-green .c-table__thead th {
      color: #76d2b6;
      border-color: #76d2b6;
    }

    .mint-green .c-table__tbody th {
      background-color: #76d2b6;
    }

    .mint-green .c-table__tbody td {
      color: #42145f;
    }

    .mint-green .survey-audience__image {
      filter: invert(75%) sepia(70%) saturate(230%) hue-rotate(108deg) brightness(91%) contrast(85%);
    }

    .mint-green .completed-html .list-group-item {
      background-color: #d6f1e9;
    }

    .mint-green .sv_main.sv_bootstrap_css .c-panel {
      background-color: #ebf8f4;
    }

    .mint-green .sv_main.sv_bootstrap_css .c-panel img {
      filter: invert(75%) sepia(70%) saturate(230%) hue-rotate(108deg) brightness(91%) contrast(85%);
    }

    .mint-green .sv_main.sv_bootstrap_css .c-checkbox__decorator {
      border-color: #42145f;
    }

    .mint-green .sv_main.sv_bootstrap_css .c-checkbox__label:focus-within {
      outline-color: #42145f;
    }

    .mint-green .sv_main.sv_bootstrap_css .c-checkbox__item img {
      filter: invert(75%) sepia(70%) saturate(230%) hue-rotate(108deg) brightness(91%) contrast(85%);
    }

    .mint-green .sv_main.sv_bootstrap_css .c-checkbox__item--select-all .c-checkbox__label {
      background-color: #42145f;
    }

    .mint-green .sv_main.sv_bootstrap_css .c-checkbox__item.checked .c-checkbox__label {
      background-color: #76d2b6;
    }

    .mint-green .sv_main.sv_bootstrap_css .c-checkbox__item.checked .c-checkbox__decorator {
      background-color: #42145f;
    }

    .mint-green .sv_main.sv_bootstrap_css .c-checkbox__item.checked.c-checkbox__item--select-all .c-checkbox__label {
      background-color: #42145f;
    }

    .mint-green .sv_main.sv_bootstrap_css .c-radio__label:focus-within .c-radio__decorator {
      outline-color: #42145f;
    }

    .mint-green .sv_main.sv_bootstrap_css .c-dropdown-description__button:focus {
      outline-color: #42145f;
    }

    @media screen and (max-width: 576px) {
      .mint-green .sv_main.sv_bootstrap_css .c-panel__title img {
        filter: invert(75%) sepia(70%) saturate(230%) hue-rotate(108deg) brightness(91%) contrast(85%);
      }
    }

    .mint-green .sv_main.sv_bootstrap_css .c-checkbox__item--select-all .c-checkbox__label {
      color: #000;
      background-color: #76d2b6;
    }

    .mint-green .sv_main.sv_bootstrap_css .c-checkbox__item--select-all .c-checkbox__label .c-checkbox__decorator {
      border-color: transparent;
    }

    .mint-green .sv_main.sv_bootstrap_css .c-checkbox__item.checked .c-checkbox__decorator {
      background-color: #fff;
      border-color: #fff;
    }

    .mint-green .sv_main.sv_bootstrap_css .c-checkbox__item.checked.c-checkbox__item--select-all .c-checkbox__label {
      background-color: #76d2b6;
    }

    .mint-green .sv_main.sv_bootstrap_css img {
      filter: invert(11%) sepia(41%) saturate(4144%) hue-rotate(264deg) brightness(93%) contrast(101%) !important;
    }

    .mint-green .sv_main.sv_bootstrap_css .c-dropdown-description__button:hover {
      color: #76d2b6;
      background-color: #fff;
    }

    .violet .c-table__thead th {
      color: #a90061;
      border-color: #a90061;
    }

    .violet .c-table__tbody th {
      background-color: #a90061;
    }

    .violet .c-table__tbody td {
      color: #000;
    }

    .violet .survey-audience__image {
      filter: invert(9%) sepia(88%) saturate(7237%) hue-rotate(318deg) brightness(79%) contrast(105%);
    }

    .violet .completed-html .list-group-item {
      background-color: #e5b2cf;
    }

    .violet .sv_main.sv_bootstrap_css .c-panel {
      background-color: #f2d9e7;
    }

    .violet .sv_main.sv_bootstrap_css .c-panel img {
      filter: invert(9%) sepia(88%) saturate(7237%) hue-rotate(318deg) brightness(79%) contrast(105%);
    }

    .violet .sv_main.sv_bootstrap_css .c-checkbox__decorator {
      border-color: #000;
    }

    .violet .sv_main.sv_bootstrap_css .c-checkbox__label:focus-within {
      outline-color: #000;
    }


    .violet .sv_main.sv_bootstrap_css .c-checkbox__item img {
      filter: invert(9%) sepia(88%) saturate(7237%) hue-rotate(318deg) brightness(79%) contrast(105%);
    }

    .violet .sv_main.sv_bootstrap_css .c-checkbox__item--select-all .c-checkbox__label {
      background-color: #000;
    }

    .violet .sv_main.sv_bootstrap_css .c-checkbox__item.checked .c-checkbox__label {
      background-color: #a90061;
    }

    .violet .sv_main.sv_bootstrap_css .c-checkbox__item.checked .c-checkbox__decorator {
      background-color: #000;
    }

    .violet .sv_main.sv_bootstrap_css .c-checkbox__item.checked.c-checkbox__item--select-all .c-checkbox__label {
      background-color: #000;
    }

    .violet .sv_main.sv_bootstrap_css .c-radio__label:focus-within .c-radio__decorator {
      outline-color: #000;
    }

    .violet .sv_main.sv_bootstrap_css .c-dropdown-description__button:focus {
      outline-color: #000;
    }

    @media screen and (max-width: 576px) {
      .violet .sv_main.sv_bootstrap_css .c-panel__title img {
        filter: invert(9%) sepia(88%) saturate(7237%) hue-rotate(318deg) brightness(79%) contrast(105%);
      }
    }

    .violet .sv_main.sv_bootstrap_css .c-checkbox__item--select-all .c-checkbox__label {
      background-color: #a90061;
    }

    .violet .sv_main.sv_bootstrap_css .c-checkbox__item--select-all .c-checkbox__label .c-checkbox__decorator {
      border-color: transparent;
    }

    .violet .sv_main.sv_bootstrap_css .c-checkbox__item.checked .c-checkbox__decorator {
      background-color: #fff;
      border-color: #fff;
    }


    .violet .sv_main.sv_bootstrap_css .c-checkbox__item.checked .c-checkbox__label__text {
      color: #fff;
    }

    .violet .sv_main.sv_bootstrap_css .c-checkbox__item.checked .c-checkbox__label__text img {
      filter: invert(100%);
    }

    .violet .sv_main.sv_bootstrap_css .c-checkbox__item.checked.c-checkbox__item--select-all .c-checkbox__label {
      background-color: #a90061;
    }

    .violet .sv_main.sv_bootstrap_css .c-dropdown-description__button:hover {
      color: #a90061;
      background-color: #fff;
    }
    
    body {
    margin: 0;
    font-family: "RO Sans", Calibri, Verdana, sans-serif !important;
    font-size: 1rem;
    font-weight: normal;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff;
}

h4 {
    margin: unset;
    font-weight: normal;
    font-size: 1.4rem;
}

h3 {
    font-size: 1.65rem !important;
    font-weight: normal;
}

h2 {
  font-size: 2rem !important;
  font-weight: normal;
}

ul.list-group {
    padding-left: 0px;
    list-style-type: circle;
}

ul.list-group > li {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    padding-left: 0px;
  }

  .list-group-item {
    padding-left: 0;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

table {
    margin-right: 0px;
    width: 100%;
}

.container {
    min-width: 992px !important;
  }

  .container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
    .container, .container-sm {
      max-width: 768px;
    }
  }
  
  @media (min-width: 768px) {
    .container, .container-sm, .container-md {
      max-width: 992px;
    }
  }
  
  @media (min-width: 992px) {
    .container, .container-sm, .container-md, .container-lg {
      max-width: 1140px;
    }
  }
  
  @media (min-width: 1200px) {
    .container, .container-sm, .container-md, .container-lg, .container-xl {
      max-width: 1200px;
    }
  }

  .navbar .container,
.navbar .container-fluid, .navbar .container-sm, .navbar .container-md, .navbar .container-lg, .navbar .container-xl {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
          flex-wrap: wrap;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

@media (max-width: 575.98px) {
    .navbar-expand-sm > .container,
    .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, 
    .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {
      padding-right: 0;
      padding-left: 0;
    }
  }

  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, 
  .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {
    -webkit-flex-wrap: nowrap;
        -ms-flex-wrap: nowrap;
            flex-wrap: nowrap;
  }

  @media (max-width: 767.98px) {
    .navbar-expand-md > .container,
    .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, 
    .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl {
      padding-right: 0;
      padding-left: 0;
    }
  }

  @media (max-width: 991.98px) {
    .navbar-expand-lg > .container,
    .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, 
    .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl {
      padding-right: 0;
      padding-left: 0;
    }
  }
`
);

export default getCustomStyling;
